import { getPage } from "./getPage";
import { updateCart } from './updateCart'; 
import { getParam } from '../helpers/getParam'; 

const addToCartAction = (sku, quantity = 1) => {
 const uid = getParam('uid'); 
 let cart = JSON.parse(localStorage.getItem(`${uid}-cart`)) || []; 

 const productId = String(sku);

 const index = cart.findIndex(item => item.id === productId);

 if (index !== -1) {
  cart[index].quantity += quantity;
 } else {
  cart.push({
   id: productId,
   quantity: quantity
  });
 }

 localStorage.setItem(`${uid}-cart`, JSON.stringify(cart));
 updateCart(); 

 $('.popup-product').show(); 
 
 $('.popup-product__in .loader').hide(); 
 $('.after-load').addClass('show'); 
 $('.popup-product__in').addClass('loaded'); 
};

const setupPopupHandlers = () => {
 $(document).off('click', '.close_popup-product').on('click', '.close_popup-product', function (e) {
  e.preventDefault(); 
  $('.popup-product').hide();
  $('.popup-product__in .loader').show();
  $('.after-load').removeClass('show');
  $('.popup-product__in').removeClass('loaded');
 });
 
 $(document).off('click', '.get_page[data-page="cart"]').on('click', '.get_page[data-page="cart"]', function () {
  window.location.href = getPage('cart');
 });
};

export const getProduct = (products, containerType) => {
 const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

 let productHTML = '';
 let numProducts;


 if (containerType === 'ha-product__content') {
  numProducts = 3;
  const randomProducts = [];
  while (randomProducts.length < numProducts) {
   const randomIndex = getRandomInt(0, products.length - 1);
   const randomProduct = products[randomIndex];
   if (!randomProducts.some(product => product.sku === randomProduct.sku)) {
    randomProducts.push(randomProduct);
   }
  }
  productHTML = randomProducts.map(product => `
   <div class="ha-product__box get_product" data-order-type="${product.sku}">
    <div class="ha-product__img">
     <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
    </div>
    <div class="ha-product__info">
     <div class="ha-product__name">${product.templates.title}</div>
     <div class="ha-product__descr">${product.description}</div>
     <div class="ha-product__sale">Special price <span class="ha-product__price">${window.options?.currency ? window.options.currency : '$'}${product.price}</span></div>
    </div>
   </div>
  `).join('');
 } else if (containerType === 'home-product__content') {
  numProducts = products.length;
  productHTML = products.map(product => `
   <div class="home-product__box get_product" data-order-type="${product.sku}">
    <div class="home-product__img">
     <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
    </div>
    <div class="home-product__name">${product.templates.title}</div>
    <div class="wrapper-flex">
     <div class="home-product__price">${window.options?.currency ? window.options.currency : '$'}${product.price}</div>
     <div class="home-product__button">
      <a href="${getPage ('product')}&id=${product.sku}" class="discover-button__purchase">Purchase</a>
      <a data-page="cart" class="add_to_cart" data-order-type="${product.sku}" data-sku="${product.sku}">Add to Bag</a> 
     </div>
    </div>
   </div>
  `).join('');
 } else if (containerType === 'product-list') {
  numProducts = products.length;
  productHTML = products.map(product => `
   ${product.templates.title} <br>
   ${product.templates.title.toUpperCase()} BOTTLE - ${window.options?.currency ? window.options.currency : '$'}${product.price}<br> <br>
  `).join('');
 } else if (containerType === 'ap-content') {
  numProducts = products.length;
  productHTML = products.map(product => `
   <div class="home-product__box get_product" data-order-type="${product.sku}">
    <div class="home-product__img">
     <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
    </div>
    <div class="home-product__name">${product.templates.title}</div>
    <div class="wrapper-flex">
     <div class="home-product__price">${window.options?.currency ? window.options.currency : '$'}${product.price}</div>
     <div class="home-product__button">
      <a href="${getPage ('product')}&id=${product.sku}" class="discover-button__purchase">Purchase</a>
      <a data-page="cart" class="add_to_cart" data-order-type="${product.sku}" data-sku="${product.sku}">Add to Bag</a>
     </div>
    </div>
   </div>
  `).join('');
 } else if (containerType === 'banner-flex') {
  numProducts = 4;
  const randomProducts = [];
  while (randomProducts.length < numProducts) {
   const randomIndex = getRandomInt(0, products.length - 1);
   const randomProduct = products[randomIndex];
   if (!randomProducts.some(product => product.sku === randomProduct.sku)) {
    randomProducts.push(randomProduct);
   }
  }
  productHTML = randomProducts.map(product => `
   <div class="banner-box">
    <div class="banner-box__img">
     <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
    </div>
    <div class="banner-box__body">
     <div class="banner-box__name">${product.templates.title}</div>
     <div class="banner-box__button get_product" data-order-type="${product.sku}">GO TO SHOP</div>
    </div>
   </div>
  `).join('');
 }

 $(`.${containerType}`).html(productHTML);

 $(document).off('click', '.add_to_cart').on('click', '.add_to_cart', function (e) {
  e.preventDefault(); 
  e.stopPropagation(); 
  
  const sku = $(this).data('order-type') || $(this).data('sku'); 
  
  if (sku) {
   addToCartAction(sku, 1);
  }
 });

 setupPopupHandlers();

 $('.get_product').click(function (e) {
  if ($(e.target).closest('.add_to_cart').length) {
   return; 
  }

  const $target = $(e.currentTarget);
  const sku = $target.data('order-type');
  localStorage.setItem('product', sku);

  window.location.href = `${getPage ('product')}&id=${sku}`
 });
};